import { render, staticRenderFns } from "./gc-field-tag.vue?vue&type=template&id=4ba2d449&"
import script from "./gc-field-tag.vue?vue&type=script&lang=js&"
export * from "./gc-field-tag.vue?vue&type=script&lang=js&"
import style0 from "./gc-field-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports